import React from "react";
import ReactPlayer from "react-player";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import { useEffect } from "react";
import { fetchMedia } from "../../redux/action/embedActions";

const MediaContent = () => {
  const dispatch = useDispatch();
  const { isLoading, mediaList } = useSelector((state) => state.embedReducer);

  useEffect(() => {
    dispatch(fetchMedia());
  }, []);
const getPlayableLink = (link, type) => {
  if (type === "local" && link.includes("drive.google.com")) {
    const fileId = link.split("/file/d/")[1]?.split("/")[0];
    return `https://drive.google.com/uc?export=download&id=${fileId}`;
  }
  return link;
};

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection label={<h1 class="mb-3">{"Media Content"}</h1>} />

      <section className="py-5 my-5">
        <div className="container">
          <div className="row">
            {mediaList?.length > 0 ? (
              mediaList?.map((item, index) => (
                <div className="col-lg-3 col-md-6 mb-4">
                  <figure className="ct_media_ocntent_card">
                    <div className="ct_media_img">
                      <ReactPlayer
                        // style={{ height: "300px" }}
                        // url={item?.link}
                        // controls
                        // width="100%"
                        // height="300"
                        // className="rounded-2xl shadow-lg"
                      url={getPlayableLink(item.link, item.type)}
                  controls
                  width="100%"
                  height="300px"
                  className="rounded-2xl shadow-lg"
                  config={{
                    youtube: { playerVars: { modestbranding: 1 } },
                    file: {
                      attributes: {
                        controlsList: 'nodownload',
                      },
                    },
                    twitch: {
                      options: {
                        parent: ["localhost"], // 🧠 Replace with your domain in production
                      },
                    },
                  }}
                      />
                    </div>
                  </figure>
                </div>
              ))
            ) : (
              <NoRecord />
            )}
            {/* <div className="col-lg-3 col-md-6 mb-4">
              <figure className="ct_media_ocntent_card">
                <div className="ct_media_img">
                  <iframe
                    width="100%"
                    height="300"
                    src="https://www.youtube.com/embed/3qS4qcl3vok?start=18"
                    title="YouTube video player"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>
              </figure>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <figure className="ct_media_ocntent_card">
                <div className="ct_media_img">
                  <ReactPlayer
                    style={{ height: "300px" }}
                    url={"img/cubotics_january_2025 (720p).mp4"}
                    controls
                    width="100%"
                    height="300"
                    className="rounded-2xl shadow-lg"
                  />
                </div>
              </figure>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <figure className="ct_media_ocntent_card">
                <div className="ct_media_img">
                  <iframe
                    width="100%"
                    height="300"
                    src="https://www.youtube.com/embed/KnHDQqlTckc"
                    title="YouTube video player"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>
              </figure>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <figure className="ct_media_ocntent_card">
                <div className="ct_media_img">
                  <iframe
                    src="https://player.twitch.tv/?video=2350155889&parent=localhost&autoplay=false"
                    width="100%"
                    height="300"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>
              </figure>
            </div> */}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MediaContent;
